export const APP_NAME = 'Fleet Assistant';

export const ONBOARDING_THREAD_ID = 'onboarding-thread';

// INFO: px, not rem: rio-uikit sets the root font-size to 10px, so a rem length here would resolve
// against 10px and come out far too small.
//
// The figure is what the open Question Panel needs to keep the Filter Toolbar on one line — Category
// Filters, Search Control and close button side by side. Those carry translated labels, so the widest
// locale sets it: 896px measured for French, with the remainder covering cross-platform font rendering.
export const COMPOSER_MAX_WIDTH = '920px';

// INFO: Capped tighter than the Chat Composer to keep the Greeting a comfortable reading width. Both of
// its lines are short enough that this only binds on a very long user name.
export const GREETING_MAX_WIDTH = '832px';

// INFO: The clearance between the Chat Composer and the Question Panel below it. Shared by the panel's
// own offset and by the room the Centred Layout reserves for it, so the two can never disagree.
export const QUESTION_PANEL_GAP = '14px';

// INFO: The height the open Question Panel occupies below the Chat Composer in the Centred Layout. The
// panel is *given* this height rather than taking it from its content, because the same figure is
// reserved as padding above — that reservation is what centres Greeting, Chat Composer and panel as one
// block, and a content-derived height would drift away from it at the first breakpoint.
//
// `100dvh - 460px` is the fit guarantee: 460px is what the rest of the block plus the wrapper's padding
// needs, so the panel can never grow taller than the room actually left for it.
export const QUESTION_PANEL_BLOCK_HEIGHT = 'clamp(200px, min(32vh, 100dvh - 460px), 340px)';

// INFO: The one declaration of the breakpoint below which the Question Panel's Filter Toolbar stacks into a
// column. Read by the panel's own styles, by the aria-orientation and arrow-key axis its toolbar advertises,
// and by the room ChatWindow reserves for the panel — so all three follow the same figure.

export const SMALL_SCREEN_QUERY = '(max-width: 47.5rem)';

// INFO: Below SMALL_SCREEN_QUERY the Filter Toolbar stacks into a column and eats roughly 130px more of the
// panel, so the reserved block grows to absorb it. It does not fully compensate: at the narrow *and* short
// end the stacked toolbar still leaves the Question List around 1.5 rows tall. Raising this floor further
// would push CENTRED_LAYOUT_QUERY up with it, since the 280px floor is what sets that gate.
export const QUESTION_PANEL_BLOCK_HEIGHT_STACKED = 'clamp(280px, min(46vh, 100dvh - 460px), 420px)';

// Consumed in @media by (keep in sync when adding a site):
//   ChatWindow.styles.tsx — the bottom reservation, and the justify-content that centres against it.
export const CENTRED_LAYOUT_QUERY = '(min-height: 670px)';

//
// Consumed in @media by (keep in sync when adding a site):
//   ChatWindow.styles.tsx               — releasing the Greeting's stretch to open the room.
//   ExampleQuestionPanel.styles.tsx     — the panel's own downward geometry.
//   ExampleQuestionPanelEntry.styles.ts — flipping the layer below the Chat Composer.
export const DOWNWARD_PANEL_QUERY = '(min-height: 650px), (min-height: 570px) and (min-width: 47.5625rem)';

// INFO: The single duration for the Centred Layout -> Bottom-Anchored Layout change on the first send.
// All three of the wrappers that move read from here: the Greeting, the Chat Composer and the reserved
// Question Panel room travel as one block, so two durations that drifted apart would tear it in flight.
//
// 300ms ease is the Chat Composer's own slot fade, reused as vocabulary. A send both withdraws the
// composer's shortcut bar slot and moves the layout, and the two should read as one motion.
export const LAYOUT_TRANSITION = '300ms';

export enum EOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
